import { render, staticRenderFns } from "./form-document-approvers.vue?vue&type=template&id=24cc34f5&scoped=true&lang=pug"
import script from "./form-document-approvers.vue?vue&type=script&lang=js"
export * from "./form-document-approvers.vue?vue&type=script&lang=js"
import style0 from "./form-document-approvers.vue?vue&type=style&index=0&id=24cc34f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc34f5",
  null
  
)

export default component.exports